import { Form, Formik } from 'formik'
import React, { useRef, useState } from 'react'
import { FaCheckDouble, FaWeightHanging } from 'react-icons/fa'
import CustomTable from '../../../shared/CustomTable'
import CustomButton from '../../../shared/CustomButton'
import ReusableModal from '../../../shared/ReuseableModal'
import { WriteOffItemColumns } from '../../../constants/InverntoryConstants'
import { DeleteIcon, EditIcon } from '../../../utils/TableActionIcons'
import WriteOffForm from './WriteOffForm'
import { useTranslation } from 'react-i18next'
import CheckPermission from '../../../hooks/CheckPermission'

function WriteOff () {
  const { hasPermission } = CheckPermission()
  const formikRef = useRef()
  const [openModal, setOpenModal] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null)
  const [rowIndex, setRowIndex] = useState(-1)
  const { t } = useTranslation()
  const actionsTemplate = (row, col) => {
    return (
      <div className='flex justify-start gap-2 items-center'>
        hasPermission('inventory', 'update') && <EditIcon
          onClick={() => {
            setSelectedItem(row)
            setOpenModal(true)
            setRowIndex(col?.rowIndex)
          }}
        />
        hasPermission('inventory', 'delete') && <DeleteIcon
          onClick={() => {
            const updated = formikRef?.current?.values?.items?.filter(
              (item, index) => {
                return index !== col?.rowIndex
              }
            )
            formikRef?.current?.setFieldValue('items', updated)
          }}
        />
      </div>
    )
  }

  const action = {
    header: t('Actions'),
    headerCellClass: '!bg-gray-200',
    body: actionsTemplate
  }
  const columns = [action, ...WriteOffItemColumns(t)]

  return (
    <Formik
      innerRef={formikRef}
      initialValues={{
        items: []
      }}
      onSubmit={values => console.log(values)}
    >
      {({ values, setFieldValue }) => (
        <Form>
          {hasPermission('inventory', 'create') && (
          <div className='flex justify-end items-center mt-4'>
            <CustomButton
              type='button'
              onClick={() => {
                setOpenModal(true)
              }}
              icon='pi pi-plus'
              label={t('AddItem')}
            />
          </div>
          )}
          <div className='mt-4'>
            <CustomTable columns={columns} data={values?.items} />
          </div>
          {hasPermission('inventory', 'create') && (
          <div className='flex justify-end mt-4'>
            <CustomButton
              type='submit'
              label={t('Submit')}
              icon={FaCheckDouble}
            />
          </div>
          )}
          <ReusableModal
            isVisible={openModal}
            position='top'
            title={t('AddItem')}
            HeaderIcon={FaWeightHanging}
            onClose={() => {
              setOpenModal(false)
            }}
          >
            <WriteOffForm
              selectedItem={selectedItem}
              setOpenModal={setOpenModal}
              setSelectedItem={setSelectedItem}
              rowIndex={rowIndex}
              setRowIndex={setRowIndex}
            />
          </ReusableModal>
        </Form>
      )}
    </Formik>
  )
}

export default WriteOff
